@import "./components/reset.css";
@import "./components/container.css";
@import "./components/buffering.css";
@import "./components/dialog.css";
@import "./components/controls.css";
@import "./components/time.css";
@import "./components/button.css";
@import "./components/button-group.css";
@import "./components/badge.css";
@import "./components/icons.css";
@import "./components/slider.css";
@import "./components/popup.css";
@import "./components/menus.css";
@import "../../shared/css/audio/icon-state.css";

/* Container */

.media-minimal-skin--audio {
  --media-default-accent-color: light-dark(oklch(0 0 0), oklch(1 0 0));
  --media-focus-ring-color: light-dark(oklch(0 0 0), oklch(1 0 0));

  --media-controls-background-color: light-dark(oklch(1 0 0), oklch(0 0 0));
  --media-controls-backdrop-filter: blur(16px) saturate(1.5);
  --media-controls-border-color: light-dark(oklch(0 0 0 / 0.1), oklch(1 0 0 / 0.1));
  --media-controls-text-color: light-dark(oklch(0 0 0), oklch(1 0 0));

  --media-dialog-transition-duration: 250ms;
  --media-dialog-transition-delay: 100ms;

  --media-popup-transition-duration: 100ms;
  --media-popup-transition-timing-function: ease-out;

  --media-popover-backdrop-filter: blur(16px) saturate(1.5);
  --media-popover-background-color: light-dark(oklch(1 0 0), oklch(0 0 0));
  --media-popover-border-color: oklch(0 0 0 / 0.1);

  --media-tooltip-backdrop-filter: var(--media-popover-backdrop-filter);
  --media-tooltip-background-color: var(--media-popover-background-color);
  --media-tooltip-border-color: var(--media-popover-border-color);

  --media-tooltip-text-color: currentColor;

  @media (prefers-reduced-motion: reduce) {
    --media-dialog-transition-duration: 50ms;
    --media-dialog-transition-delay: 0ms;
    --media-popup-transition-duration: 0ms;
  }

  @media (prefers-reduced-transparency: reduce) or (prefers-contrast: more) {
    --media-tooltip-background-color: light-dark(oklch(1 0 0), oklch(0 0 0));
  }
}

/* Dialog */

.media-minimal-skin--audio .media-dialog__dialog {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  gap: calc(var(--media-spacing) * 4);
  align-items: center;
  padding-inline: calc(var(--media-spacing) * 3) calc(var(--media-spacing) * 1);
  background-color: oklch(from var(--media-controls-background-color) l c h / 1);
  border-radius: calc(Infinity * 1px);
  transition-delay: var(--media-dialog-transition-delay);
  transition-timing-function: ease-out;
  transition-duration: var(--media-dialog-transition-duration);
  transition-property: opacity, filter, scale;
}

.media-minimal-skin--audio .media-dialog__popup[data-starting-style] .media-dialog__dialog,
.media-minimal-skin--audio .media-dialog__popup[data-ending-style] .media-dialog__dialog,
.media-minimal-skin--audio media-error-dialog[data-starting-style] .media-dialog__dialog,
.media-minimal-skin--audio media-error-dialog[data-ending-style] .media-dialog__dialog {
  opacity: 0;
  filter: blur(4px);
  scale: 0.95;
}
.media-minimal-skin--audio .media-dialog__popup[data-ending-style] .media-dialog__dialog,
.media-minimal-skin--audio media-error-dialog[data-ending-style] .media-dialog__dialog {
  transition-delay: 0ms;
}

.media-minimal-skin--audio .media-dialog__content {
  display: flex;
  flex: 1;
  gap: calc(var(--media-spacing) * 2);
  align-items: center;
}

/* Controls */

.media-minimal-skin--audio .media-controls {
  --media-base-side-offset: 2;
  --media-base-boundary-offset: 2;

  gap: calc(var(--media-spacing) * 2);
  color: var(--media-controls-text-color);
  border-radius: var(--media-border-radius, calc(var(--media-spacing) * 3.5));
  box-shadow: 0 0 0 1px var(--media-controls-border-color);
}

/* Buffering (spinner over play button — backdrop only, no layout change) */

.media-minimal-skin--audio .media-button--play__wrapper {
  position: relative;
  display: inline-flex;
}

.media-minimal-skin--audio .media-button--play__wrapper .media-buffering-indicator {
  color: inherit;
}

.media-minimal-skin--audio
  .media-button--play__wrapper:has(.media-buffering-indicator[data-visible])
  .media-button--play
  .media-icon {
  opacity: 0;
}

/* Popups & Animations */

.media-minimal-skin--audio .media-popover--volume {
  --media-popover-side-offset: 0rem;
  padding: 0 calc(var(--media-spacing) * 2) 0 calc(var(--media-spacing) * 16);
  background: linear-gradient(to left, var(--media-controls-background-color) 80%, transparent 100%);
}

.media-minimal-skin--audio .media-slider .media-slider__preview .media-slider__value {
  bottom: calc(var(--media-spacing) * 10);
}
